interface UsernameGate {
	promise: Promise<void>
	resolve: () => void
}

let activeGate: UsernameGate | null = null

export function waitForUsernameCompletion(): Promise<void> {
	if (!activeGate) {
		let resolve!: () => void
		const promise = new Promise<void>((complete) => {
			resolve = complete
		})
		activeGate = { promise, resolve }
	}

	return activeGate.promise
}

export function completeUsernameGate(): void {
	const gate = activeGate
	activeGate = null
	gate?.resolve()
}
